(() => {
  const selector = '.price,.compare-at-price,.unit-price,.upupa-card .p,.upupa-cycle__price,.upupa-party__price,[data-party-total],[data-package-summary-price],[data-package-price],[data-package-regular],[data-package-saving],[data-flex-total],[data-flex-regular],.cart-items__price,.cart-items__unit-price-wrapper,.cart-totals__total-value,.cart-totals__original-value,.cart-discounts__value,.cart-summary__total-value,.cart__total-value,.totals__total-value,[ref="cartTotal"]';
  function format(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      if (!node.parentElement || node.parentElement.closest('.upupa-money-value,.visually-hidden,select,input,textarea,script,style,[contenteditable="true"]')) return;
      const text = node.textContent;
      const pattern = /\d+(?:[\s\u00a0\u202f.,]\d{3})*[,.]\d{2}(?!\d)/g;
      const matches = Array.from(text.matchAll(pattern));
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      let start = 0;
      matches.forEach(match => {
        fragment.append(text.slice(start, match.index));
        const amount = document.createElement('span'); amount.className = 'upupa-money-value';
        const accessible = document.createElement('span'); accessible.className = 'visually-hidden'; accessible.textContent = match[0];
        const visual = document.createElement('span'); visual.setAttribute('aria-hidden', 'true');
        visual.append(match[0].slice(0, -2));
        const cents = document.createElement('span'); cents.className = 'upupa-money-cents'; cents.textContent = match[0].slice(-2);
        visual.append(cents); amount.append(accessible, visual); fragment.append(amount);
        start = match.index + match[0].length;
      });
      fragment.append(text.slice(start)); node.replaceWith(fragment);
    });
  }
  let scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll(selector).forEach(format);
  }
  function queue() {
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(scan);
  }
  function init() {
    scan();
    new MutationObserver(records => {
      if (records.some(record => !record.target.parentElement?.closest('.upupa-money-value'))) queue();
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();